<p-toast position="top-right"></p-toast>
<app-confirm-dialog
  [visible]="confirmationDialogVisible"
  variant="secondary"
  heading="Confirmation"
  message="Are you sure you want to update Settings?"
  cancelText="No"
  (confirmed)="confirmUpdateConfirmation()"
  (cancelled)="cancelUpdateConfirmation()">
</app-confirm-dialog>
<div class="globle-responsive p-g">
  <div class="p-g-12">
    <div class="p-g-12">
      <p-toolbar>
        <div class="globalBtnMain p-toolbar-group-left p-toolbar-tecfolk-fix">
          <app-action-button
            variant="secondary"
            size="sm"
            text="{{ setLabel('backBtnLabel') }}"
            icon="pi pi-arrow-left"
            title="{{ setLabel('backBtnLabel') }}"
            ariaLabel="{{ setLabel('backBtnLabel') }}"
            routerLink="/members"
            [disabled]="false">
          </app-action-button>
          <app-action-button
            variant="secondary"
            size="sm"
            text="{{ setLabel('updateBtnLabel') }}"
            icon="pi pi-save"
            title="{{ setLabel('updateBtnLabel') }}"
            ariaLabel="{{ setLabel('updateBtnLabel') }}"
            [disabled]="false"
            (action)="update()">
          </app-action-button>
        </div>
      </p-toolbar>
    </div>
    <p-tabView>
      <p-tabPanel [header]='setLabel("settingsHeaderLabel")'>
        <div class="displayFlextonDirRTL globle-field-main-date card card-w-title">
          <div class="p-g-12 p-md-6 p-xl-4 dueDateMain">
            <h3>{{setLabel("defaultDueDateLabel")}}</h3>
            <p-calendar class="p-calendar" [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
              [(ngModel)]="setting.dueDate" [placeholder]='setLabel("dueDatePlaceholderLabel")' name="dueDate" [inline]="false" dateFormat="dd/mm/yy"
              [showIcon]="true"></p-calendar>
          </div>
          <div class="p-g-12 p-md-6 p-xl-4 startingdateMain">
            <h3>{{setLabel("gymStartingDateLabel")}}</h3>
            <p-calendar class="p-calendar" [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
              [(ngModel)]="setting.gymStartingDate" [placeholder]='setLabel("gymStartingDatePlaceholderLabel")' name="gymStartingDate"
              [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
          </div>
          <div style="clear: both;"></div>
        </div>
      </p-tabPanel>
      <!-- <p-tabPanel header="Member Form Fields">
        <div class="card card-w-title">
          <app-form-fields></app-form-fields> -->
      <!-- <div class="p-g-12 p-md-4">
            <h3>Default Due Date</h3>
            <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="setting.dueDate" placeholder="Due Date" name="dueDate" [inline]="false"
              dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
          </div>
          <div class="p-g-12 p-md-4">
            <h3>Gym Starting Date</h3>
            <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="setting.gymStartingDate" placeholder="Gym Starting Date" name="gymStartingDate" [inline]="false"
              dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
          </div>
          <div style="clear: both;"></div> -->
      <!-- </div>
      </p-tabPanel> -->
    </p-tabView>
  </div>
</div>